export default "__VITE_ASSET__CNIxmpUE__"